import React from "react";
import { Link } from "@reach/router";
import styled from "@emotion/styled";
import { RailsUrl } from "@services";
import { useStoreAppValue } from "@hooks";
import { Box, Heading, TextUppercase, TouchableOpacity, Flex } from "@atoms";

// == Types ================================================================

interface IProps {
  title?: string;
  collectionId: string;
  count?: number;
  onTitlePress: () => void;
}

// == Constants ============================================================

// == Component ============================================================

// == Component ============================================================

const CollectionTitle = ({ count, title, collectionId, onTitlePress }: IProps) => {
  const {
    featureFlags: { newCollection },
    campaignId,
  } = useStoreAppValue();

  const clickCollectionLink = () => {
    if (onTitlePress) onTitlePress();
  };

  // feature flag
  if (newCollection) {
    const renderViewAllLink = () => {
      if (count && count > 1) {
        return (
          <Link to={RailsUrl.collectionUrl({ id: collectionId, campaignId })}>
            <Box>
              <TextUppercase fontSize={[0, 1]}>View All ({count})</TextUppercase>
            </Box>
          </Link>
        );
      }
      return false;
    };

    return (
      <Flex justifyContent="space-between" mb={2}>
        {!!title && (
          <ELink to={RailsUrl.collectionUrl({ id: collectionId, campaignId })}>
            <Heading ellipsis fontSize={[2, 3]}>
              {title}
            </Heading>
          </ELink>
        )}
        {renderViewAllLink()}
      </Flex>
    );
  }

  const renderViewAllLink = () => {
    if (count && count > 1) {
      return (
        <TouchableOpacity onTouch={clickCollectionLink}>
          <Box>
            <TextUppercase fontSize={[0, 1]}>View All ({count})</TextUppercase>
          </Box>
        </TouchableOpacity>
      );
    }
    return false;
  };

  return (
    <Flex justifyContent="space-between" mb={2}>
      {!!title && (
        <TouchableOpacity onTouch={clickCollectionLink}>
          <Heading fontSize={[2, 3]}>{title}</Heading>
        </TouchableOpacity>
      )}
      {renderViewAllLink()}
    </Flex>
  );
};

export default CollectionTitle;

// == Styles ===============================================================

const ELink = styled(Link)`
  width: 70%;
`;
